const FORM_CONSTANT =   {
    PRESCRIPTION:"Prescription",
    PRESCRIPTION_2:"Prescription self-planned",
    RETAINER:"Retainer",
    REFINEMENT:"Refinement",
    REFINEMENT_2: "Refinement self-planned", 
}

export default FORM_CONSTANT